"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consumeNaniClubTokenFromUrl = exports.getNaniLoginToken = exports.clearNaniLoginToken = exports.setNaniLoginToken = exports.redirectToLogin = exports.redirectToNaniClubLogin = exports.getNaniClubAuthUrl = exports.getIsNaniClubEnabled = exports.configureNaniClub = void 0;

var _common = require("../utils/common");

var _domain = require("../utils/domain");

var _constants = require("../constants");

var TOKEN_QUERY_KEY = "token";
var OIDC_AUTH_PATH = "/oidc/auth";
var config = {
  apiUrl: "",
  clientId: ""
};
/**
 * 設定產品自己的 Nani Club 參數
 *
 * 在 app 進入點呼叫一次（ReactDOM.render 之前），之後這支 service 的其他函式就不用再帶參數。
 * @param {object} params
 * @param {string} params.apiUrl Nani Club API 網域
 * @param {string} params.clientId 產品各環境自己的 client_id
 */

var configureNaniClub = function configureNaniClub() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      apiUrl = _ref.apiUrl,
      clientId = _ref.clientId;

  config = {
    apiUrl: apiUrl || "",
    clientId: clientId || ""
  };
};
/**
 * Nani Club 登入入口是否可用
 *
 * @returns {boolean}
 */


exports.configureNaniClub = configureNaniClub;

var getIsNaniClubEnabled = function getIsNaniClubEnabled() {
  if (!config.apiUrl || !config.clientId) return false;
  return (0, _domain.getIsNaniDomain)();
};

exports.getIsNaniClubEnabled = getIsNaniClubEnabled;

var getNaniClubAuthUrl = function getNaniClubAuthUrl() {
  var params = new URLSearchParams({
    client_id: config.clientId
  });
  return "".concat(config.apiUrl).concat(OIDC_AUTH_PATH, "?").concat(params.toString());
};

exports.getNaniClubAuthUrl = getNaniClubAuthUrl;

var redirectToNaniClubLogin = function redirectToNaniClubLogin() {
  window.location.href = getNaniClubAuthUrl();
};
/**
 * 把未登入的使用者送去登入
 *
 * nani 網域直接開 Nani Club 授權頁（不經過站內登入頁），
 * oneclass 網域維持站內帳密登入頁。
 * @param {object} history react-router 的 history
 */


exports.redirectToNaniClubLogin = redirectToNaniClubLogin;

var redirectToLogin = function redirectToLogin(history) {
  if (getIsNaniClubEnabled()) {
    redirectToNaniClubLogin();
    return;
  }

  history.push(_constants.LOGIN_PATH);
};
/**
 * 寫入會員 JWT
 *
 * cookie 效期跟著 token 的 exp 走，Nani Club 那邊調整 token 效期不用改這裡。
 * @param {string} jwt
 */


exports.redirectToLogin = redirectToLogin;

var setNaniLoginToken = function setNaniLoginToken(jwt) {
  (0, _common.setCookieByJwtExpire)(_constants.COOKIE_NANI_LOGIN_TOKEN_NAME, JSON.stringify({
    code: "SUCCESS",
    jwt: jwt
  }), jwt);
};

exports.setNaniLoginToken = setNaniLoginToken;

var clearNaniLoginToken = function clearNaniLoginToken() {
  (0, _common.deleteCookie)(_constants.COOKIE_NANI_LOGIN_TOKEN_NAME);
};
/**
 * 讀取會員 JWT
 * @returns {string} 沒有或格式不對時回傳空字串
 */


exports.clearNaniLoginToken = clearNaniLoginToken;

var getNaniLoginToken = function getNaniLoginToken() {
  var cookie = (0, _common.getCookie)(_constants.COOKIE_NANI_LOGIN_TOKEN_NAME);
  if (!cookie) return "";

  try {
    return JSON.parse(cookie).jwt || "";
  } catch (error) {
    return "";
  }
};
/**
 * 從網址撿 Nani Club 導回的 token 並寫進 cookie
 *
 * 消化後會把 token 從網址移除，避免 JWT 留在網址列、瀏覽歷史與 referrer。
 * 必須在 AuthProvider 掛載前呼叫，AuthMachine 才判斷得到已登入。
 * @returns {string|null} 網址上沒有 token 時回傳 null
 */


exports.getNaniLoginToken = getNaniLoginToken;

var consumeNaniClubTokenFromUrl = function consumeNaniClubTokenFromUrl() {
  var url = new URL(window.location.href);
  var token = url.searchParams.get(TOKEN_QUERY_KEY);
  if (!token) return null;
  setNaniLoginToken(token);
  url.searchParams.delete(TOKEN_QUERY_KEY);
  window.history.replaceState(window.history.state, "", url.toString());
  return token;
};

exports.consumeNaniClubTokenFromUrl = consumeNaniClubTokenFromUrl;